module.exports = __webpack_public_path__ + "img/astronaut.41c8a1b2.svg";